// extracted by mini-css-extract-plugin
module.exports = {"container":"CampaignsDialogControl_container__1zUC4"};